import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../../component/Header";
import api from "../../Services/api";
import { useSwal } from "../../component/sweetalert";
import Select from "react-select";
import "../AddBlog/index.css";

export default function EditTallyAddon() {
  const { id } = useParams();
  const navigate = useNavigate();
  const alert = useSwal();

  const [formData, setFormData] = useState({
    tally: "",
    Tally_Url: "",
  });

  const [iconFile, setIconFile] = useState(null);
  const [blogOptions, setBlogOptions] = useState([]);
const [loading, setLoading] = useState(false);

useEffect(() => {
  const fetchData = async () => {
    try {
      const [addonRes, blogRes] = await Promise.all([
        api.post(`/getTallyAddonById/${id}`),
        api.post("/AllBlogView"),
      ]);

      const blogs = blogRes.data?.data || blogRes.data || [];

      const formattedBlogs = blogs.map((blog) => ({
        label: blog.heading,
        value: blog.view_url,
      }));

      setBlogOptions(formattedBlogs);

      setFormData({
        tally: addonRes.data.data.tally,
        Tally_Url: addonRes.data.data.Tally_Url || "",
      });
    } catch (error) {
      console.error("❌ Error fetching data:", error);
      alert("error", "Failed to fetch Tally Addon details");
    }
  };

  if (id) fetchData();
}, [id, alert]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // const handleSelectChange = (selectedOption) => {
  //   setFormData({ ...formData, Tally_Url: selectedOption?.value || "" });
  // };
const handleSelectChange = (selectedOption) => {  
  setFormData({
    ...formData,
    Tally_Url: selectedOption ? selectedOption.value : "", // ✅ set empty string when cleared
  });
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const updatedData = new FormData();
      updatedData.append("tally", formData.tally);
      updatedData.append("Tally_Url", formData.Tally_Url);
      if (iconFile) {
        updatedData.append("Tally_Icon", iconFile);
      }

      await api.post(`/editTallyAddon/${id}`, updatedData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      alert("success", "Tally Addon updated successfully!");
      navigate("/tally-addons");
    } catch (error) {
      console.error("❌ Error updating Tally Addon:", error);
      alert("error", "Failed to update Tally Addon");
    }finally {
      setLoading(false);
    }
  };

  return (
    <section className="dashboardpage">
      <Header pageTitle="Edit Our Plug & Play Module Details" backTo="/tally-addons" />
      <div className="pageLeftspace">
        <div className="d-flex justify-content-start col-xl-6 col-12">
          <form className="form-fields d-flex" onSubmit={handleSubmit}>
            <div className="grid-container user">
              <div className="input-container">
                <input
                  type="text"
                  name="tally"
                  placeholder="Enter Tally Addon"
                  value={formData.tally}
                  onChange={handleChange}
                  required
                />
                <span className="underline"></span>
              </div>

              <div className="input-container">
                <Select
                  options={blogOptions}
                  value={blogOptions.find((opt) => opt.value === formData.Tally_Url)}
                  onChange={handleSelectChange}
                  placeholder="Select Blog"
                  isClearable
              //  menuIsOpen= {true}
                />
              </div>

              <div className="input-container file-input-container">
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setIconFile(e.target.files[0])}
                />
                <span className="underline"></span>
              </div>

         

              
            <button className="btn btn-purpal" type="submit" disabled={loading}>
              {loading ? "Updating..." : "Update"}
            </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
